import { useContext, useEffect } from 'react'

import ContentManagementContext, {
  ContentType,
} from 'routes/content-management/ContentManagement/ContentManagementProvider/Context'
import ContentModal from 'routes/content-management/ContentManagement/components/ContentModal'

type CreateContentModalProps = {
  contextType: ContentType
  show: boolean
  onHide: () => void
  contentItem: any
}

const CreateContentModal = ({ contextType, show, onHide, contentItem }: CreateContentModalProps) => {
  const { setFocusedContentItem, focusedContentItem } = useContext(ContentManagementContext)

  useEffect(() => {
    if (show) {
      setFocusedContentItem({ IsHidden: false, ContentType: contextType, ...contentItem })
    }
  }, [contentItem, contextType, setFocusedContentItem, show])

  const handleOnHide = () => {
    setFocusedContentItem(undefined)
    onHide()
  }

  if (!focusedContentItem) return null

  return (
    <ContentModal
      show={Boolean(focusedContentItem)}
      onHide={handleOnHide}
      contentItem={focusedContentItem}
      type={focusedContentItem.ContentType}
    />
  )
}

export default CreateContentModal
